import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

// Utility function for password validation
const validatePasswords = (password, confirmPassword) => {
    if (confirmPassword && password !== confirmPassword) {
        return "Passwords do not match";
    }
    return "";
};

function ResetPassword() {
    const navigate = useNavigate();
    const { uid, token } = useParams();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        setError(validatePasswords(newPassword, confirmPassword));
    };

    const handleConfirmPasswordChange = (e) => {
        const newConfirmPassword = e.target.value;
        setConfirmPassword(newConfirmPassword);
        setError(validatePasswords(password, newConfirmPassword));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password === confirmPassword) {
            setLoading(true);
            try {
                const response = await fetch(
                    "https://api.ananasai.site/users/reset_password_confirm/",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            uid,
                            token,
                            new_password: password,
                        }),
                    }
                );

                setLoading(false);

                if (response.status === 204) {
                    navigate("/success-password");
                } else {
                    const responseBody = await response.json();
                    const formattedErrors = Object.entries(responseBody)
                        .map(([key, value]) => `${key}: ${value[0]}`)
                        .join("\n");
                    setError(formattedErrors);
                }
            } catch (error) {
                setLoading(false);
                console.error("Error:", error);
                setError("An unexpected error occurred.");
            }
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen">
            <div className="bg-black/30 rounded-xl shadow-lg max-w-md w-full p-6 text-center">
                <header>
                    <h2 className="text-xl font-bold mb-2 text-white">Create New Password</h2>
                    <p className="text-gray-300 mb-6">
                        Please enter your new password below for your Ananas Calorie Tracker account.
                    </p>
                </header>
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <div className="flex flex-col text-left">
                        <label htmlFor="password" className="font-semibold text-white">
                            New Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={password}
                            onChange={handlePasswordChange}
                            required
                            className="p-3 text-white border border-gray-300 rounded-md bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div className="flex flex-col text-left">
                        <label htmlFor="confirmPassword" className="font-semibold text-white">
                            Confirm New Password
                        </label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={handleConfirmPasswordChange}
                            required
                            className="p-3 text-white border border-gray-400 rounded-md bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {error && <p className="text-red-500 font-bold">{error}</p>}

                    <button
                        type="submit"
                        disabled={!!error || loading}
                        className={`flex justify-center items-center h-12 rounded-md font-bold transition-colors ${loading || error
                            ? "bg-gray-500 cursor-not-allowed"
                            : "bg-primary text-white"
                            }`}
                    >
                        {loading ? (
                            <div
                                className="w-5 h-5 border-4 border-white/50 border-t-blue-500 rounded-full animate-spin"></div>
                        ) : (
                            "Reset Password"
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default ResetPassword;
